'use strict';
import Axios from 'axios';
import store from '@/store';

const baseURL = (process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : '') + process.env.VUE_APP_API;
const axios = Axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    'X-Frame-Options': 'SAMEORIGIN',
    'Content-Security-Policy': `script-src "self" ${window.location.origin}`,
    'Permissions-Policy': `geolocation=(self ${window.location.origin})`,
    'X-Content-Type-Options': 'nosniff',
    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
  },
});

axios.interceptors.response.use(
  (response) => response,
  (e) => {
    if (e.status === 403) {
      store.dispatch('closeSocket');
    }
    return Promise.reject(e);
  },
);

export { axios };
